import { axiosCore } from './http-core-service';

export const getEtablissements = async (
    designation: string | undefined,
    page: number,
    rowsPerPage: number,
    sort?: string
) => {
    sort = sort ?? '';
    const response = await axiosCore.get(
        `/etablissement_information?page=${page}&itemsPerPage=${rowsPerPage}&pagination=true` +
            sort +
            '&designationOfficielle=' +
            designation
    );
    return {
        etablissements: response.data.data,
        totalItems: response.data.totalItems,
    };
};

export const createEtablissementVisibilite = async (
    etablissementId: number,
    dateModification: Date,
    visible: boolean,
    compteAbonne: string
) => {
    const datas = {
        etablissementId,
        dateModification,
        visible,
        compteAbonne,
    };
    const responseGet = await axiosCore.get('/etablissementVisibilite?etablissementId=' + etablissementId);
    if (responseGet.data['hydra:member'].length > 0) {
        const etablissementVisibiliteId = responseGet.data['hydra:member'][0].id;
        const response = await axiosCore.put('/etablissementVisibilite/' + etablissementVisibiliteId, datas);
        return response.data;
    } else {
        const response = await axiosCore.post('/etablissementVisibilite', datas);
        return response.data;
    }
};
